import { Sun, Droplets, Cloud, Wind, Clock, ShieldCheck, Wrench, FileCheck2, ArrowRight } from "lucide-react";

const features = [
  { icon: Sun, title: "Protección solar 95%", desc: "Bloquea hasta el 95% de la radiación UV directa." },
  { icon: Droplets, title: "Semi impermeable 80%", desc: "Hasta un 80% de resistencia a lluvia en membrana arquitectónica." },
  { icon: Cloud, title: "100% bajo lluvia directa", desc: "Cuando se utiliza material impermeable." },
  { icon: Wind, title: "Resistencia 70 km/hr", desc: "Estructura diseñada para altos niveles de viento." },
  { icon: Clock, title: "Vida útil 20 años", desc: "Materiales importados de primera calidad." },
  { icon: ShieldCheck, title: "Garantía 10 años por escrito", desc: "Cobertura total en materiales y mano de obra." },
  { icon: Wrench, title: "Sin soldadura en sitio", desc: "Sistema modular que se arma de manera segura." },
  { icon: FileCheck2, title: "No requiere permiso de construcción", desc: "Estructura desmontable: sin trámite municipal." },
];

export default function Features() {
  return (
    <section id="caracteristicas" className="bg-neutral-50 py-20 md:py-28">
      <div className="container-x">
        <div className="text-center mb-12">
          <span className="eyebrow">Por qué FlexShade</span>
          <h2 className="mt-4 section-title text-4xl md:text-6xl font-black">
            Ingeniería <span className="text-red-600">probada</span>, garantía por escrito
          </h2>
          <p className="mt-4 text-neutral-600 max-w-2xl mx-auto">
            8 características clave que hacen de FlexShade el sistema modular más confiable del mercado.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {features.map((f, i) => (
            <div key={i} className="bg-white rounded-2xl p-5 md:p-6 card-lift border border-neutral-200 hover:border-orange-400">
              <div className="w-12 h-12 rounded-xl bg-orange-50 flex items-center justify-center mb-4">
                <f.icon className="w-6 h-6 text-orange-600" strokeWidth={2} />
              </div>
              <h3 className="font-bold text-neutral-900 text-base md:text-lg leading-snug">{f.title}</h3>
              <p className="text-sm text-neutral-600 mt-2 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a href="#proyectos" className="inline-flex items-center gap-2 text-red-600 font-bold hover:text-red-700">
            Ver galería de proyectos reales <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
